import { useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

export function NudgeTechButton({ job, onDone, compact, testid = "nudge-tech-button" }) {
  const [busy, setBusy] = useState(false);
  if (job?.tech_ack !== "in_attesa" || !job.technician_id) return null;
  const run = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      await api.post(`/admin/jobs/${job.id}/nudge`);
      toast.success(`Sollecito inviato a ${job.technician_name}`);
      onDone?.();
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button size="sm" variant="outline" className="rounded-full border-amber-300 text-amber-800" onClick={run} disabled={busy} data-testid={testid}>
      {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <BellRing className="h-4 w-4" />}{compact ? " Sollecita" : " Sollecita il tecnico"}
    </Button>
  );
}
